import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getDeliveryPreferenceDefaults } from "../deliveryPreferenceForm";

const DISPLAYED_WORKS = ["Les miens", "Ceux du cabinet"];

export const ScopePreferences = withForm({
  defaultValues: getDeliveryPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, ["displayedWorks"]);

    return (
      <SaveableCard
        title="Périmètre"
        description="Ce que vous voyez dans l'app"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <Text variant="strong">Travaux affichés</Text>
          <form.Field name="displayedWorks">
            {field => (
              <Group>
                {DISPLAYED_WORKS.map(displayedWork => (
                  <ButtonCheckbox
                    key={displayedWork}
                    id={displayedWork}
                    isActive={field.state.value === displayedWork}
                    onClick={() => field.handleChange(displayedWork)}
                  >
                    {displayedWork}
                  </ButtonCheckbox>
                ))}
              </Group>
            )}
          </form.Field>
        </Stack>
      </SaveableCard>
    );
  },
});
